export const unFormatPhoneNumber = (phone: string): string => {
  if (!phone) return '';
  return `+${phone.replace(/\D+/g, '')}`;
};
